__turbopack_context__.v({
  "image-collage": "ImageCollage-module-scss-module__uvJPZG__image-collage",
  "image-collage__image": "ImageCollage-module-scss-module__uvJPZG__image-collage__image",
  "image-collage__item": "ImageCollage-module-scss-module__uvJPZG__image-collage__item",
});
